module.exports = __webpack_public_path__ + "firefox.png?f8152d1bdf1f08060471823d19bee260";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/point/firefox.png
// module id = 938
// module chunks = 0